<ng-container *ngIf="getOriginContactFullName()">
  <hr class="divider" />
  <div class="d-flex flex-column">
    <span class="address-headers">
      {{
        isSameContact() ? ('pickupAndDeliveryContact' | translate) : ('pickupContact' | translate)
      }}
    </span>
    <span>
      {{ getOriginContactFullName() }}
    </span>
    <span>{{ summaryData.locationInfo?.originContactPhoneNumber }}</span>
    <span>{{ handleIsExternal(summaryData.locationInfo?.isOriginContactExternal) }}</span>
  </div>
</ng-container>
<ng-container *ngIf="!isSameContact()">
  <hr class="divider" />
  <div class="d-flex flex-column">
    <span class="address-headers">{{ 'deliveryContact' | translate }}</span>
    <span>
      {{ getDestinationContactFullName() }}
    </span>
    <span>{{ summaryData.locationInfo?.destinationContactPhoneNumber }}</span>
    <span>{{ handleIsExternal(summaryData.locationInfo?.isDestinationContactExternal) }}</span>
  </div>
</ng-container>
<ng-container *ngIf="summaryData.BillingAddress?.DisplayName && summaryData.BillingAddress?.FiscalCode">
  <hr class="divider" />
  <div class="d-flex flex-column">
    <span class="address-headers">{{ 'billingCenter' | translate }}</span>
    <span>{{ summaryData.BillingAddress?.DisplayName }}</span>
    <span>CIF: {{ summaryData.BillingAddress?.FiscalCode }}</span>
  </div>
</ng-container>
<hr class="divider" />
